import { render, staticRenderFns } from "./customIndicatorsComponent.vue?vue&type=template&id=3c7fb3f0"
import script from "./customIndicatorsComponent.vue?vue&type=script&lang=js"
export * from "./customIndicatorsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports